import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

//Constants
import { FontFamilyBold, FontFamilyRegular } from "../../constants"

//Assets
import InfoGrey from "../../images/info-grey.png";

// Define Interface
type Props = {
  className?: string;
  icon?: string;
  tooltip?: JSX.Element;
  placement?: "bottom" | "top" | "right" | "left";
}

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>`
  display:inline-block;
  position:relative;
  text-align:left;
  cursor: pointer;
  margin-left: 6px;

  .icon{
    width: 10px;
    height: 10px;
  }

  .bottom {
    min-width:269px;
    top:28px;
    left:50%;
    transform:translate(-50%, 0);
    padding:16px;
    color:#666666;
    background-color:#242424;
    border-radius:12px;
    position:absolute;
    box-sizing:border-box;
    display:none;

    .tooltip-wrapper{
      .info{
        font-family: ${props => props.fontFamilyRegular};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        margin-bottom:16px;
      }
      .learn-more{
        font-family: ${props => props.fontFamilyBold};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        margin-bottom:0;
      }
    }

    i {
      position:absolute;
      bottom:100%;
      left:50%;
      margin-left:-12px;
      width:24px;
      height:12px;
      overflow:hidden;

      &::after{
        content:'';
        position:absolute;
        width:12px;
        height:12px;
        left:50%;
        transform:translate(-50%,50%) rotate(45deg);
        background-color:#242424;
      }
    }
  }

  &:hover{
    .bottom {
      display:block;
    }
  }
`
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}

const Tooltips: FC<Props> = ({
  icon,
  tooltip,
  placement,
  className
}) => {
  return (
    <StyledComponent className={className}>
      <KickImage className="icon" src={icon || InfoGrey} alt="icon" />
      <div className="bottom">
        {
          tooltip ? tooltip :
            <div className="tooltip-wrapper">
              <p className="info">
                We are working with an external insurance company to make sure the product you order arrives safe and sound.
              </p>
              <p className="info">Insurance coverage depends on the logistic
                company of your choosing. Please note that
                the terms and conditions may vary.</p>
              <p className="learn-more">Learn More</p>
            </div>
        }
        <i></i>
      </div>
    </StyledComponent>
  )
}
Tooltips.defaultProps = {
  className: "",
  icon: "",
  placement: "bottom"
}

export default Tooltips;